// extracted by mini-css-extract-plugin
export var searchHeader = "_77-0";
export var searchHeaderDark = "_77-1";